import WizardTypeStep from './WizardTypeStep';
import './WizardTypeStep.scss';

export default WizardTypeStep;
